import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { AdminModuleRoutes } from "modules/AdminModule/AdminModule.routes";
import { GenericModuleRoutes } from "modules/GenericModule/GenericModule.routes";
import { MainModuleRoutes } from "modules/MainModule/MainModule.routes";
import { AuthModuleRoutes } from "modules/AuthModule/AuthModule.routes";
import { InvitesModuleRoutes } from "modules/InvitesModule/InvitesModule.routes";
import { OnboardingModuleRoutes } from "modules/OnboardingModule/OnboardingModule.routes";

import React from "react";
import { RouteObject } from "react-router-dom";
import { ResultModuleRoutes } from "modules/ResultsModule/ResultsModule.routes";
import { GroupsModuleRoutes } from "modules/GroupsModule/GroupsModule.routes";
import { TeamManagementModuleRoutes } from "modules/TeamManagementModule/TeamManagementModule.routes";
import { OrgManagementModuleRoutes } from "modules/OrgManagementModule/OrgManagementModule.routes";
import { EnterpriseManagementModuleRoutes } from "modules/EnterpriseManagementModule/EnterpriseManagementModule.routes";
import { ProfileModuleRoutes } from "modules/ProfileModule/ProfileModule.routes";
import { useHomePageRedirect } from "hooks/useHomePageRedirect";
import { CompareModuleRoutes } from "modules/CompareModule/CompareModule.routes";

const RedirectPage: React.FC = () => {
  useHomePageRedirect();
  return <LoadingPage />;
};

export const routes: RouteObject[] = [
  GenericModuleRoutes,
  ResultModuleRoutes,
  GroupsModuleRoutes,
  MainModuleRoutes,
  AdminModuleRoutes,
  AuthModuleRoutes,
  InvitesModuleRoutes,
  TeamManagementModuleRoutes,
  OrgManagementModuleRoutes,
  EnterpriseManagementModuleRoutes,
  ProfileModuleRoutes,
  OnboardingModuleRoutes,
  CompareModuleRoutes,
  {
    path: "/",
    Component: RedirectPage,
  },
  {
    path: "/*",
    Component: RedirectPage,
  },
];
